module.exports = __webpack_public_path__ + "static/media/NotFound.a9d15d85.gif";